























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

import FormLayout from '../FormLayout.vue';

import BaseSelect from '@/components/select/BaseSelect.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';
import ScheduleDayField, { defineEmptyScheduleDay } from './ScheduleDayField.vue';

import { formatDateForInput, getWeekdayName, getWeekdayShortName } from '@/utils/date';

import { getWeekday } from '@/utils/date';

import { typeItems } from './const';

import { SelectItem } from '@/components/select/types';
import { ISOCalendarDate } from '@/utils/date/types';
import { ScheduleDay, ScheduleEditForm } from './types';
import {BackendSlotCustom} from "@/api/calendar/backend";

const defineEmptyScheduleForDate = (date: ISOCalendarDate): ScheduleDay => {
    const weekday = getWeekday(date);

    return defineEmptyScheduleDay(weekday);
}

@Component({
    components: {
        FormLayout,
        BaseSelect,
        ScheduleDayField,
        BaseButton,
    },
})
export default class FormScheduleEdit extends Vue {
    @Prop({ required: true }) date!: ISOCalendarDate
    @Prop({ default: () => [] }) clinics!: SelectItem[]
    @Prop({ default: () => [] }) custom!: BackendSlotCustom

    form: ScheduleEditForm = {
        date: this.date,
        type: null,
        clinic: null,
        schedule: defineEmptyScheduleForDate(this.date),
    }

    get humanReadableDate() {
        const date =  formatDateForInput(this.date);
        const weekday = getWeekdayName(this.date);

        return `${date}, ${weekday}`;
    }

    get typeItems() {
        return typeItems;
    }

    get weekname() {
        return getWeekdayShortName(this.date)
    }

    get isCustom() {
        return this.custom !== null;
    }

    get customText() {
        return 'test';
    }

    get customCreatedAt() {
        return this.isCustom ? moment(this.custom.created_at).format('DD-MM-YYYY [в] HH:mm:ss') : '-';
    }

    get customUpdatedAt() {
        return this.isCustom ? moment(this.custom.updated_at).format('DD-MM-YYYY [в] HH:mm:ss') : '-';
    }

    @Watch('date')
    updateFormDate(date: ISOCalendarDate) {
        this.form.date = date;
    }

    updateSchedule() {
        this.$emit('schedule:clinic', this.form);
    }
    
    closeForm() {
        this.$emit('schedule:cancel');
    }
}
